<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <div class="main-container">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  data() {
    return {
      locale: zhCN
    }
  },
  mounted () {
    document.body.style.fontSize = '14px'
  }
}
</script>

<style lang="less">
#app {
  position: relative;
  background: #c1c1c1;
}

.main-container {
  width: 1000px;
  height: 90%;
  position: absolute;
  left: 50%;
  top: 5%;
  transform: translate(-50%, 0);
  // overflow: hidden;
  border-radius: 4px;
}
</style>
